
import { Button} from "@material-ui/core";
import GeneratePRNModal from "./GeneratePRNModal";
import { useEffect, useState } from "react";
import moment from 'moment'
import { useDispatch } from "react-redux";
import { getLatestValidFromAction } from "../../../../redux/modules/SSSPRNGenerator/prnGenerator";

const SSSContributionGeneratePRN = ({ validTransactions, data, transaction, styles, classes, updateBillerTxn }) => {
    let dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false)

    useEffect(()=>{
        dispatch(getLatestValidFromAction());
    },[])

    const handleOpenModal = (e) =>{
        setOpenModal(true)
    }

    const handleOnCloseModal = (prnData) => {
        if(prnData) {
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "amount",
                value: prnData.amount,
            });
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "referenceNumber",
                value: prnData.prn,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "PayorName",
                value: prnData.accountName,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "From",
                value: moment(prnData.applicableDateFrom, "MMYYYY").format("MM/DD/YYYY"),
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "To",
                value: moment(prnData.applicableDateTo, "MMYYYY").format("MM/DD/YYYY"),
            })
        }
        setOpenModal(false)
    }

	return (
        <>
            <div  style={{width: "100%"}}/>
            <div  style={{width: "200px"}}>
                <label className={classes.prnGeneratorLabel}>
                    For those that don't have a Payment Reference Number, use PRN Generator
                </label>
            </div>
            <div  style={{width: "200px"}}>
                <Button variant="contained" color="inherit" size="medium" className={classes.generatePRNbtn} onClick={handleOpenModal}>
                    Generate PRN
                </Button>
            </div>
            <div>
                <GeneratePRNModal open={openModal} handleOnCloseModal={handleOnCloseModal}/>
            </div>
        </>
	);
};

export default SSSContributionGeneratePRN;